import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { DateUtils } from 'react-day-picker';
import { isArray, isDate, isString, toArray } from '../type';
import { getTime, toDate, validateDate } from './index';
export var getSingleDate = function getSingleDate(value) {
  return toDate(value);
};
export var getMultipleDate = function getMultipleDate(value) {
  return toArray(value).length > 0 ? toArray(value).map(function (item) {
    return toDate(item);
  }) : toArray(value);
};
export var getDateRange = function getDateRange(value) {
  if (!value) return {};
  var from;
  var to;

  if (isArray(value)) {
    var _value = _slicedToArray(value, 2),
        fromDateVal = _value[0],
        toDateVal = _value[1];

    from = fromDateVal;
    to = toDateVal;
  } else if (isString(value)) {
    var _value$split = value.split(' '),
        _value$split2 = _slicedToArray(_value$split, 3),
        _fromDateVal = _value$split2[0],
        _toDateVal = _value$split2[2];

    from = _fromDateVal;
    to = _toDateVal;
  }

  var result = {
    from: null,
    to: null,
    enteredTo: null,
    delimiter: '-'
  };

  if (validateDate(from)) {
    result.from = toDate(from);
  }

  if (validateDate(to)) {
    result.to = toDate(to);
    result.enteredTo = toDate(to);
  }

  return result;
};
export var getDateByType = function getDateByType(value, _ref) {
  var multiple = _ref.multiple,
      withRange = _ref.withRange;

  if (withRange) {
    return getDateRange(value);
  }

  if (multiple) {
    return getMultipleDate(value);
  }

  return getSingleDate(value);
};
export var getDayAtRange = function getDayAtRange(day, rangeData) {
  if (getTime(day) >= getTime(rangeData.from) && getTime(day) <= getTime(rangeData.enteredTo)) {
    return true;
  }

  return false;
};
export var getTimeByDateType = function getTimeByDateType(value, _ref2) {
  var withRange = _ref2.withRange;

  if (withRange) {
    if (value.from && isDate(value.from)) return value.from.getTime();
    return null;
  }

  return isDate(value) ? value.getTime() : null;
};
export var getIsSelectingFirstDay = function getIsSelectingFirstDay(from, to, day) {
  var isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
  var isRangeSelected = from && to;
  return !from || isBeforeFirstDay || isRangeSelected;
};